import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withRouter from './WithRouter';
import classnames from 'classnames';
import { addOrganization, listOrganizations } from '../actions/organization';

var z = 0

class LoadToStore extends React.Component {

  constructor() {
      super();
      this.state = {
          list: []
      }
  }

  componentDidMount() {

    if(z===0){
      this.props.listOrganizations('dada', this.props.history);
      // this.timeout = setInterval(() => {
      //   console.log('message');
      // }, 2000);
      z++
    }
  }

  render() {
    return (
      ''
    );
  }
}

LoadToStore.propTypes = {
    listOrganizations: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps,{ listOrganizations })(withRouter(LoadToStore))
